import React, { forwardRef, Ref, useImperativeHandle, useRef, useState } from 'react';

import { ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import { StyledConfirmOrCancelModal } from 'src/presentation/components/pages/shared/rowActions/StyledConfirmOrCancelModal';

export type DeleteConfirmationModalRef = {
  show: ({ title, subscribe }: { title: string; subscribe: () => void }) => void;
};

const DeleteConfirmationModal = forwardRef((_, ref: Ref<DeleteConfirmationModalRef>) => {
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [title, setTitle] = useState('');
  const refCallbacks = useRef<{ subscribe: () => void } | null>(null);

  useImperativeHandle(ref, () => ({
    show: ({ title, subscribe }) => {
      setIsDeleteModalVisible(true);
      setTitle(title);
      refCallbacks.current = { subscribe };
    },
  }));

  if (!isDeleteModalVisible) {
    return null;
  }

  const handleSubmit = () => {
    if (refCallbacks.current?.subscribe) {
      refCallbacks.current.subscribe();
      handleClose();
    }
  };

  const handleClose = () => {
    setIsDeleteModalVisible(false);
    refCallbacks.current = null;
  };

  return (
    <StyledConfirmOrCancelModal
      cancelText="Cancel"
      onCancel={() => setIsDeleteModalVisible(false)}
      onSubmit={handleSubmit}
      submitButtonType={ButtonTypes.DANGER}
      cancelButtonType={ButtonTypes.TEXT}
      submitText="Delete"
      text="Are you sure you want to delete this? This action cannot be undone."
      title={title}
    />
  );
});

export default DeleteConfirmationModal;
